// src/store/store.js
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import hashtagReducer from "./hashtagSlice"
import profileReducer from "./profileSlice"
import campaignBuilderReducer from "./campaignBuilderSlice"
import planReducer from "./planSlice"
import nicheReducer from "./nicheSlice"

export const store = configureStore({
    reducer: {
        auth: authReducer,
        hashtag: hashtagReducer,
        profile: profileReducer,
        campaignBuilder: campaignBuilderReducer,
        plan: planReducer,
        niche: nicheReducer,
    },
});
